import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SoldData = () => {
  const params = useParams();
  const navigate = useNavigate();

  const { user } = useSelector(state => state.user);

  const id = params.id;

  const [sold, setSold] = useState();
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`/sell/${id}`);
        if (response.data.success) {
          setSold(response.data.selling);
          // toast.success(response.data.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    })();
  }, []);



  return (
    <>
      <div className="flex flex-col">
        <div className="text-center py-2 mx-3 mt-2 bg-blue-200 rounded-lg border-2 border-blue-600">
          <button onClick={() => navigate(`/invoice/${id}`)} className="btn btn-primary ml-3">Invoice</button>
        </div>

        <div className="w-full ">
          <h1 className="text-2xl bg-blue-300 mx-3 rounded-lg text-center mt-2 font-bold py-1">
            sold Information
          </h1>

          <div className=" flex flex-row flex-wrap gap-5 mx-10 my-4">
            <div className="">
              <h1 className="text-xl">
                <span className="font-bold">Date:</span>{" "}
                <span className="text-blue-700 font-bold">
                  {new Date(sold?.date).toLocaleDateString("en-GB")}
                </span>
              </h1>

              {/* <h1 className="text-xl">
                <span className="font-bold">Product Category:</span>{" "}
                <span className="text-blue-700 font-bold">
                  {sold?.category?.title}
                </span>
              </h1> */}
              <h1 className="text-xl">
                <span className="font-bold">Total Amount:</span>{" "}
                <span className="text-blue-700 font-bold">
                  <span>&#8377;</span>{sold?.totalAmount.toLocaleString('en-IN')}
                </span>
              </h1>
              <h1 className="text-xl">
                <span className="font-bold">Payment Method:</span>{" "}
                <span className="text-blue-700 font-bold">
                  {sold?.paymentMethod}
                </span>
              </h1>
              <h1 className="text-xl">
                <span className="font-bold">Sales Person:</span>{" "}
                <span className="text-blue-700 font-bold">
                  {user?.name} ({user?.email})
                </span>
              </h1>

            </div>


          </div>
        </div>

        <div className="w-full space-y-2">
          <h1 className="text-2xl bg-blue-300 mx-3 rounded-lg text-center mt-2 font-bold py-1">
            Customer Information
          </h1>
          <div className="px-10 p-4">
            <h1 className="text-xl">
              <span className="font-bold">Name:</span>{" "}
              <span className="text-blue-700 font-bold">
                {sold?.customer?.name}
              </span>
            </h1>
            <h1 className="text-xl">
              <span className="font-bold">Phone No:</span>{" "}
              <span className="text-blue-700 font-bold">
                {sold?.customer?.phoneNo}
              </span>
            </h1>
            <h1 className="text-xl">
              <span className="font-bold">Address:</span>{" "}
              <span className="text-blue-700 font-bold">
                {sold?.customer?.address}
              </span>
            </h1>
          </div>
        </div>

        <div className="w-full space-y-2">
          <h1 className="text-2xl bg-blue-300 mx-3 rounded-lg text-center mt-2 font-bold py-1">
            Product Information
          </h1>
          <div className="overflow-x-auto mt-5">
            <table className="table">
              <thead>
                <tr>
                  <td className="text-xl text-black font-bold"></td>
                  <td className="text-xl text-black font-bold">Category</td>
                  <td className="text-xl text-black font-bold">Product Name</td>
                  <td className="text-xl text-black font-bold">Material Code</td>
                  <td className="text-xl text-black font-bold">MRP</td>
                  <td className="text-xl text-black font-bold">Quantity</td>
                  <td className="text-xl text-black font-bold">Price</td>
                  <td className="text-xl text-black font-bold">GST</td>
                  <td className="text-xl text-black font-bold">Discount</td>
                  <td className="text-xl text-black font-bold">Total</td>

                </tr>
              </thead>

              {sold?.products.map((product, index) => {
                return <tbody>
                  <tr>
                    <td className="text-xl text-black font-bold">{index + 1}</td>
                    <td className="text-xl text-blue-700 font-bold">{sold?.category?.title || product?.category?.title}</td>
                    <td className="text-xl text-blue-700 font-bold">{product?.product?.name}</td>
                    <td className="text-xl text-blue-700 font-bold">{product?.product?.materialCode}</td>
                    <td className="text-xl text-blue-700 font-bold">{product?.product?.MRP}</td>
                    <td className="text-xl text-blue-700 font-bold">{product?.quantity}</td>
                    <td className="text-xl text-blue-700 font-bold">{product?.price}</td>
                    <td className="text-xl text-blue-700 font-bold">{product?.sellingGst}%</td>
                    <td className="text-xl text-blue-700 font-bold">{product?.discount}%</td>
                    <td className="text-xl text-blue-700 font-bold"><span>&#8377;</span>{product?.total.toLocaleString('en-IN')}</td>
                  </tr>
                </tbody>;
              })}
            </table>
          </div>

          <div className="text-center">
            <h1 className="bg-blue-500 inline text-2xl font-bold text-white p-2 rounded-lg mt-4">Total Amount: {sold?.totalAmount.toLocaleString("en-IN")}/-</h1>
          </div>


        </div>
      </div>
    </>
  );
};

export default SoldData;
